import { Component, OnInit, ViewChild } from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';
import { ChangeExamScheduleStartDateTimeModel } from 'src/app/interface/dto';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-change-exam-schedule-start-date-time',
  templateUrl: './change-exam-schedule-start-date-time.component.html',
  styleUrls: ['./change-exam-schedule-start-date-time.component.scss']
})
export class ChangeExamScheduleStartDateTimeComponent implements OnInit {

  constructor( private examSchService: ExamScheduleService, private snackBar: SnackbarService) { }
  changeDateOnly: boolean = true;

  changeDateTimeModel: ChangeExamScheduleStartDateTimeModel = {
    ids: [],
    dateOnly: false,
    restartExam: false,
    viaEmail: false,
    emailMessage: '',
    emailSubject: '',
    startDateTime: '',
    endDateTime: ''
  };
  toast = {
    visible: false,
    x: 0,
    y: 0
  };
   quill: any = {};
  @ViewChild('editor') editor: QuillEditorComponent;
  ngOnInit(): void {
  }


  async yesClicked() {
    this.changeDateTimeModel.ids = this.examSchService.selectedSchedules.map(x => x.id);
    const res = await this.examSchService.changeScheduleStatus(this.changeDateTimeModel) as any[];
      if(res !== null && res.length > 0){
        res.forEach(e =>{
          this.snackBar.error(e);
        })        
      }
      else{
        this.snackBar.success('Examination Schedule Start Date/Time changed Successfully!');
      }
    this.examSchService.reloadGrid.next(true);
    window.history.back();
  }


  onDateOnlyChange(event){
    this.changeDateOnly = event.target.checked;
    this.changeDateTimeModel.dateOnly = event.target.checked;
  }

  onStartDateChange(event){
    
    this.changeDateTimeModel.startDateTime = event.target.value;
  }

  onEndDateChange(event){
    
    this.changeDateTimeModel.endDateTime = event.target.value;
  }
  
  copyPlaceholder(text: string, event: MouseEvent) {
    navigator.clipboard.writeText(text);
    // Insert into Quill at cursor position
    this.insertIntoQuill(text);
    const target = event.target as HTMLElement;
    const rect = target.getBoundingClientRect();

    // Position toast beside the span
    this.toast.x = rect.right + 10; // 10px to the right
    this.toast.y = rect.top;

    this.toast.visible = true;

    // Hide after 1.2 seconds
    setTimeout(() => {
      this.toast.visible = false;
    }, 1200);
  }
  onEditorReady(quill: any) {
    this.quill = quill;
  }
  insertIntoQuill(text: string) {
    if (!this.quill) return;

    const range = this.editor.quillEditor.getSelection(true);

    if (range) {
      // Insert text at cursor
      this.editor.quillEditor.insertText(range.index, text);

      // Move cursor to end of inserted text
      this.editor.quillEditor.setSelection(range.index + text.length, 0);
    } else {
      // If no cursor (editor not focused), append at end
      const length = this.editor.quillEditor.getLength();
      this.editor.quillEditor.insertText(length, text);
    }
    this.changeDateTimeModel.emailMessage = this.quill.root.innerHTML;
    console.log(this.changeDateTimeModel, "data");

  }
}
